import axios from "axios";
import { closeLoading } from "../common/LoadingAction";
import toastJs from "../notification/toastJs";
import { CookiesHelper } from "../common/cookiesHelper";
import { loginType } from "../../../share/base/constants/login";

const configJs = window.$.pvi_env_config();
const apiUrl = configJs.REACT_APP_URL_API;

/**
 * Xử lý lỗi chung cho tất cả API calls
 * @param {Error} e - Error object
 * @param {boolean} showLoading - Có đang hiển thị loading không
 * @returns {Object} - Object chứa thông tin lỗi
 */
const handleApiError = (e, showLoading = true) => {
  if (showLoading) {
    closeLoading();
  }

  // Connection timeout
  if (e && e.code === "ECONNABORTED") {
    toastJs.error("Kết nối bị timeout, vui lòng thử lại");
    return { isError: true, errorType: "TIMEOUT", message: "Connection timeout" };
  }

  // Network error (no response)
  if (!e?.response) {
    toastJs.error("Lỗi kết nối mạng, vui lòng kiểm tra kết nối");
    return { isError: true, errorType: "NETWORK", message: "Network error" };
  }

  const status = e.response.status;

  // Unauthorized - logout user
  if (status === 401) {
    CommonBase.setLogOut();
    return { isError: true, errorType: "UNAUTHORIZED", message: "Phiên đăng nhập hết hạn" };
  }

  // Forbidden
  if (status === 403) {
    toastJs.error("Bạn không có quyền thực hiện thao tác này");
    return { isError: true, errorType: "FORBIDDEN", message: "Access denied" };
  }

  // Not Found
  if (status === 404) {
    toastJs.error("Không tìm thấy dữ liệu");
    return { isError: true, errorType: "NOT_FOUND", message: "Not found" };
  }

  // Server Error
  if (status >= 500) {
    toastJs.error("Lỗi hệ thống, vui lòng thử lại sau");
    return { isError: true, errorType: "SERVER_ERROR", message: "Server error" };
  }

  // Other errors - show message from server if available
  const mesError = e?.response?.data?.message || "Có lỗi xảy ra";
  toastJs.error(mesError);
  return { isError: true, errorType: "API_ERROR", message: mesError };
};

var CommonBase = {
  delete(api, data, onSuccess, onError) {
    axios
      .delete(apiUrl + api, {
        params: data,
      })
      .then(function (response) {
        if (onSuccess) onSuccess(response.data);
      })
      .catch(function (error) {
        if (onError) onError(error);
      });
  },
  get(api, data, onSuccess, onError) {
    axios
      .get(apiUrl + api, {
        params: data,
      })
      .then(function (response) {
        if (onSuccess) onSuccess(response.data);
      })
      .catch(function (error) {
        if (onError) onError(error);
      });
  },
  post(api, data, onSuccess, onError) {
    axios
      .post(apiUrl + api, data, { "Content-Type": "application/json" })
      .then(function (response) {
        if (onSuccess) onSuccess(response.data);
      })
      .catch(function (error) {
        if (onError) onError(error);
      });
  },
  put(api, data, onSuccess, onError) {
    axios
      .put(apiUrl + api, data, { "Content-Type": "application/json" })
      .then(function (response) {
        if (onSuccess) onSuccess(response.data);
      })
      .catch(function (error) {
        if (onError) onError(error);
      });
  },
  async postFile(api, data, onSuccess, onError) {
    let formData = new FormData();
    formData.append("files", data.files[0]);
    formData.append("typeFile", data.typeFile);
    axios
      .post(apiUrl + api, formData, { "Content-Type": "multipart/form-data" })
      .then(function (response) {
        if (onSuccess) onSuccess(response.data);
      })
      .catch(function (error) {
        if (onError) onError(error);
      });
  },
  async deleteAsync(api, data) {
    try {
      var result = await axios.delete(
        apiUrl + api,
        {
          params: data,
        },
        { "Content-Type": "application/json" }
      );
      return result.data;
    } catch (e) {
      handleApiError(e);
      return false;
    }
  },
  async getAsync(api, data) {
    try {
      var result = await axios.get(
        apiUrl + api,
        {
          params: data,
        },
        { "Content-Type": "application/json" }
      );
      return result.data;
    } catch (e) {
      handleApiError(e);
      return false;
    }
  },

  async postAsync(api, data) {
    try {
      let result = await axios.post(apiUrl + api, data, {
        "Content-Type": "application/json",
      });

      return result.data;
    } catch (e) {
      handleApiError(e);
      return false;
    }
  },
  async putAsync(api, data) {
    try {
      let result = await axios.put(apiUrl + api, data, {
        "Content-Type": "application/json",
      });
      return result.data;
    } catch (e) {
      handleApiError(e);
      return false;
    }
  },
  setAuthHeader(token) {
    axios.defaults.timeout = 30000;
    axios.defaults.headers.common["Authorization"] = token
      ? "Bearer " + token
      : "";
  },

  setLogOut() {
    axios.defaults.headers.common["Authorization"] = "";
    CookiesHelper.remove(loginType.loginCookieName);
    window.location.href = process.env.PUBLIC_URL + "/dang-nhap";
  },

  async postAsyncExportExcel(api, data) {
    try {
      let result = await axios.post(apiUrl + api, data, {
        "Content-Type": "application/json",
        responseType: "blob",
      });
      return result;
    } catch (e) {
      handleApiError(e);
      return false;
    }
  },

  async getAsyncFile(api) {
    try {
      var result = await axios.get(apiUrl + api, {
        "Content-Type": "application/json",
        responseType: "blob",
      });
      return result;
    } catch (e) {
      handleApiError(e);
      return false;
    }
  },
  setLanguaueHeader(lang) {
    CookiesHelper.set("language", lang, 30);
    axios.defaults.headers.common["languaue"] = lang;
  },
};

export default CommonBase;
